module.exports = __webpack_public_path__ + "static/media/debo.04c70f1a.png";